import React, { useState } from "react";
import { Tooltip } from "@UI/Components/Tooltip/Tooltip";
import { Box } from "@UI/Components/Box/Box";
import messages from "../messages";
import useThemeToken from "@UI/hooks/useThemeToken";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { SolidInfoCircle } from "@UI/Components/Icons/SolidInfoCircle";
import { Icon } from "@UI/Components/Icon/Icon";
import { Money } from "@Shared/Components/Money/Money";
import { useOrderDescription } from "../useOrderDescription";
import { IOrder } from "@modules/Purchasing/services/orders";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";

export type SavingProps = {
  order: IOrder;
};

export const Savings = ({ order }: SavingProps) => {
  const { totalServiceFees, totalExpensesFees, currency } =
    useOrderDescription(order);
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

  const { currentUser } = useCurrentUser({
    includes: ["currentSubscription"],
  });

  const pink500 = useThemeToken("colors", "pink.500");
  const orange500 = useThemeToken("colors", "orange.500");
  const pink600 = useThemeToken("colors", "pink.600");
  const orange600 = useThemeToken("colors", "orange.600");

  const formatedAmount = (
    <Money cents={totalServiceFees + totalExpensesFees} currency={currency} />
  );

  return (
    <>
      {currentUser?.currentSubscription && (
        <Tooltip
          label={
            <FormattedMessage
              {...messages.youSavedTooltipMessage}
              values={{
                amountSaved: formatedAmount,
              }}
            />
          }
          textAlign="center"
          placement="auto"
          isOpen={isTooltipOpen}
        >
          <Box
            w="fit-content"
            display="flex"
            margin="auto"
            p="4px 12px"
            justifyContent="center"
            alignItems="center"
            borderRadius={100}
            color="white"
            onClick={() => setIsTooltipOpen(!isTooltipOpen)}
            onMouseLeave={() => setIsTooltipOpen(false)}
            onMouseEnter={() => setIsTooltipOpen(true)}
            background={`linear-gradient(96.51deg, ${pink500} 0%, ${orange500} 99.87%);`}
            _hover={{
              background: `linear-gradient(96.51deg, ${pink600} 0%, ${orange600} 99.87%);`,
            }}
          >
            <FormattedMessage
              {...messages.youSaved}
              values={{
                amountSaved: formatedAmount,
              }}
            />
            <Icon pl="3" as={SolidInfoCircle} color="white" />
          </Box>
        </Tooltip>
      )}
    </>
  );
};
